<template>
    <div>
        <div class="flex">
            <h3 class="flex-1">Summary</h3>

            <div v-if="service.issuerUrl">
                <a :href="service.issuerUrl" target="_blank" class="no-underline">
                    <i class="far fa-file-download text-black mr-1"></i>
                    Download Certificate
                </a>
            </div>
        </div>

        <div class="border py-12 px-6" v-if="display">
            <div class="flex flex-col md:flex-row">
                <div class="w-full md:w-1/2 md:mx-6 border-b pb-4 mb-4">
                    <h5>Issuer</h5>
                    <p class="mb-0 pb-0">
                        {{ service.productName }}
                    </p>
                </div>
                <div class="w-full md:w-1/2 md:mx-6 border-b pb-4 mb-4">
                    <h5>Domain</h5>
                    <p class="mb-0 pb-0">
                        {{ service.domain }}
                    </p>
                </div>
            </div>
            <div class="flex flex-col md:flex-row">
                <div class="w-full md:w-1/2 md:mx-6 border-b pb-4 mb-4 md:border-none md:pb-0 md:mb-0">
                    <h5>Status</h5>
                    <p class="mb-0 pb-0">{{ service.status }}</p>
                </div>
                <div class="w-full md:w-1/2 md:mx-6">
                    <h5>Expires On</h5>
                    <p class="mb-0 pb-0">{{ service.expiresAtFormatted }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['service'],

    data: function () {
        return {
            display: false,
        };
    },

    created: function () {
        if (this.service.status.toLowerCase() != 'suspended') {
            this.display = true;
        }
    },

    computed: {
        domainUrl: function ()
        {
            let schemes = ['//', 'http://', 'https://'];

            for (var i = 0; i < schemes.length; i++) {
                if (this.service.domain.startsWith(schemes[i])) {
                    return this.service.domain;
                }
            }

            return `//${this.service.domain}`;
        },
    }
}
</script>
